import "./index.css";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, NavLink } from "react-router-dom";
import { saveMyRole, saveProfile } from "../../redux/actions";
import Firebase from "../../firebasehelper";
// import { resetPassword } from "../../api/UserApi";
import { isUnbrandedSite } from "../../Utils/utils";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import landingImg from "../../images/login/illustration.png";
import EcoLogo from "../../assets/media/ecosystem_logo.png";
import BrandLogo from "./components/BrandLogo";

export default function LogIn() {
  const history = useHistory();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [resettingPassword, setResettingPassword] = useState(false);
  const [_newPassword, setNewPassword] = useState("");
  const [_confirmPassword, setConfirmPassword] = useState("");
  const [_uid, setUID] = useState("");

  const auth = getAuth();
  const isLister = window.location.host.includes("list");
  const isNotAdmin = process.env.REACT_APP_USER !== "admin";
  const isUnbranded = isUnbrandedSite();

  const onChangeHandler = (e) => {
    if (e.target.name === "newPassword") setNewPassword(e.target.value);
    if (e.target.name === "confirmPassword") setConfirmPassword(e.target.value);
    if (e.target.name === "email") setEmail(e.target.value);
    if (e.target.name === "password") setPassword(e.target.value);
  };

  const subBrandNavigation = (adminType, username, role, brand) => {
    dispatch(saveMyRole("isSubBrand"));

    const isAdminTypeInArray = [
      "Sales rep",
      "Service rep",
      "Service manager",
      "Sales manager",
    ].includes(adminType);

    let path = "";
    if (
      adminType === "Content and marketing" ||
      adminType === "Content Admin"
    ) {
      path = "/articles";
    } else if (adminType === "Marketplace lister") {
      path = "/products";
    } else if (isAdminTypeInArray) {
      path = "/users";
    } else {
      path = "/users";
    }

    history.push(path, {
      username: username,
      role: role,
      brand: brand,
      type: adminType,
    });
  };

  const signIn = () => {
    Firebase.signIn(email, password, (res) => {
      if (res === "success") {
        let uid = Firebase.getCurrentUser().uid;
        localStorage.setItem("uid", uid);
        Firebase.getAgencyData(uid, (res) => {
          if (!res) {
            Firebase.getAuth()
              .signOut()
              .then(() => {
                localStorage.clear();
                history.push("/");
              })
              .catch(() => {
                localStorage.clear();
                history.push("/");
              });
            return;
          }
          let { username, role, approved, brand, shouldReset } = res;
          if (shouldReset) {
            Firebase.getAuth()
              .signOut()
              .then(() => {
                setUID(uid);
                setResettingPassword(true);
                setEmail("");
                setPassword("");
                localStorage.clear();
              });
          } else if (approved) {
            dispatch(saveProfile(res));
            if (process.env.REACT_APP_USER === "admin") {
              // If user is not super admin, umberlla admin or brand admin
              if (role !== 0 && role !== 10 && role !== 2) {
                alert("Your account is not authorized.");
                return;
              }
            } else {
              if (role === 0) {
                alert("Your account is not authorized.");
                return;
              }
            }
            localStorage.setItem("uid", uid);

            if (process.env.REACT_APP_USER === "admin") {
              if (brand && (role === 2 || role === 10)) {
                dispatch(saveMyRole("isUmbrella"));
                localStorage.setItem("umbrella", brand); // Umbrella Admin
                history.push("/umbrella-channel", {
                  username: username,
                  role: role,
                });
              } else {
                dispatch(saveMyRole("isSuper"));
                localStorage.removeItem("umbrella"); //Super Admin
                history.push("/today-snapshot", {
                  username: username,
                  role: role,
                });
              }
            } else {
              subBrandNavigation(res.type, username, role, brand);
            }
          } else {
            alert(
              "Your account is yet to be approved by an admin. Please wait to be approved."
            );
          }
        });
      } else alert(res);
    });
  };

  const passwordReset = async () => {
    if (email === "") {
      return;
    }
    await sendPasswordResetEmail(auth, email);
    console.log("Password reset email sent", email);
    alert(
      `The email for resetting password is sent to ${email}. Please check your inbox.`
    );
    setResettingPassword(false);
    // if (!uid) {
    //   setResettingPassword(false);
    //   setNewPassword("");
    //   setConfirmPassword("");
    //   return;
    // }

    // if (newPassword !== confirmPassword) {
    //   alert("Please confirm your password!");
    //   return;
    // }

    // resetPassword(uid, newPassword)
    //   .then(() => {
    //     Firebase.updateAgencyData(uid, {
    //       shouldReset: false,
    //     });
    //     setResettingPassword(false);
    //     setNewPassword("");
    //     setConfirmPassword("");
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //     alert("Something went wrong! Please try again later");
    //   });
  };

  const onKeyPress = (e) => {
    if (e.which === 13 || e.charCode === 13) {
      signIn();
    }
  };

  return (
    <div id="page-container">
      <main id="main-container login-container">
        <div className="bg-image">
          <div className="row no-gutters bg-opacity">
            <div className=" col-md-6 d-flex align-items-center bg-white">
              <div
                className="px-3 py-5 w-100"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                }}
              >
                <div className="mb-3 text-center login-logo-container">
                  {isUnbranded && (
                    <img
                      src={EcoLogo}
                      alt="ecosystem logo"
                      className="login-logo"
                    />
                  )}
                  {isNotAdmin &&
                    (!isUnbranded ? (
                      <BrandLogo />
                    ) : (
                      <p className="brand-hub-text">
                        Your hub for community communication,<br></br>
                        engagement, gamification and loyalty.
                      </p>
                    ))}
                </div>
                <div className="row no-gutters justify-content-center">
                  <div className="col-sm-8 col-xl-6">
                    {resettingPassword ? (
                      <form
                        className="js-validation-signin"
                        action="/dashboard"
                        method="post"
                      >
                        <div className="py-3">
                          <div className="form-group">
                            <input
                              type="email"
                              className="form-control form-control-lg form-control-alt"
                              id="login-email"
                              name="email"
                              placeholder="Email"
                              onChange={onChangeHandler}
                              value={email}
                            />
                          </div>
                          {/* <div className="form-group">
                              <input
                                type="password"
                                className="form-control form-control-lg form-control-alt"
                                id="new-password"
                                name="newPassword"
                                placeholder="New Password"
                                onChange={onChangeHandler}
                                onKeyPress={onKeyPress}
                                value={newPassword}
                              />
                            </div>
                            <div className="form-group">
                              <input
                                type="password"
                                className="form-control form-control-lg form-control-alt"
                                id="confirm-password"
                                name="confirmPassword"
                                placeholder="Confirm Password"
                                onChange={onChangeHandler}
                                onKeyPress={onKeyPress}
                                value={confirmPassword}
                              />
                            </div> */}
                        </div>

                        <div className="form-group">
                          <button
                            type="button"
                            className="btn btn-block btn-hero-lg btn-hero-primary"
                            onClick={passwordReset}
                            disabled={!email}
                            // disabled={!newPassword || !confirmPassword}
                          >
                            Reset Password
                          </button>
                        </div>
                      </form>
                    ) : (
                      <form
                        className="js-validation-signin"
                        action="/dashboard"
                        method="post"
                      >
                        <div className="py-3">
                          <div className="form-group">
                            <input
                              type="email"
                              className="form-control form-control-lg form-control-alt"
                              id="login-email"
                              name="email"
                              placeholder="Email"
                              onChange={onChangeHandler}
                              value={email}
                            />
                          </div>
                          <div className="form-group">
                            <input
                              type="password"
                              className="form-control form-control-lg form-control-alt"
                              id="login-password"
                              name="password"
                              placeholder="Password"
                              onChange={onChangeHandler}
                              onKeyPress={onKeyPress}
                              value={password}
                            />
                          </div>
                        </div>

                        <div className="form-group">
                          <button
                            type="button"
                            className="btn btn-block btn-hero-lg btn-hero-primary"
                            onClick={signIn}
                          >
                            {`Log into your ${
                              isUnbranded ? "Ecosystem" : "CRM"
                            }`}
                          </button>
                        </div>
                        {isNotAdmin && (
                          <div className="form-group">
                            <a>
                              <button
                                type="button"
                                className="btn btn-block btn-hero-lg btn-hero-success"
                                onClick={() => setResettingPassword(true)}
                              >
                                Reset your password
                              </button>
                            </a>
                          </div>
                        )}
                      </form>
                    )}
                    {isNotAdmin && isUnbranded && !isLister && (
                      <a
                        href="https://crm.ecosystem.co.uk/signup"
                        className="btn-register"
                      >
                        Create your own Ecosystem
                      </a>
                    )}
                    {isNotAdmin && isLister && (
                      <NavLink
                        to="/register?brand=eyelineads&type=marketplacelister"
                        className="btn-register"
                      >
                        Sign up as Marketplace Lister
                      </NavLink>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-6"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "white",
                padding: "16px",
              }}
            >
              <img
                className="landing-img"
                src={landingImg}
                alt="landing image"
              />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/LogIn/index.js